import { AuthResource } from './auth.resource';
class AuthService {
    constructor() {
        this.authResource = new AuthResource();
    }
    async login(email, password) {
        return this.authResource.login(email, password);
    }
    async logout() {
        return this.authResource.logout();
    }
}
export default new AuthService();
